import {Middleware} from '@modifi/redux'
import {companyActionTypes} from './entity'
import {userActionTypes} from '../user'

const companyMiddleware: Middleware =
  store =>
  next =>
  (action): any => {
    if (typeof action !== 'function') {
      // eslint-disable-next-line default-case
      switch (action.type) {
        case userActionTypes.PENDING:
          store.dispatch({
            ...action,
            type: companyActionTypes.PENDING,
          })
          return next(action)
        case userActionTypes.SUCCESS: {
          // extract the company from our OnboardingUserAndCompanyView
          const {
            payload: {company, ...restPayload},
          } = action
          // store.dispatch({
          //   type: companyActionTypes.SUCCESS,
          //   payload: company,
          // })
          store.dispatch({
            type: companyActionTypes.SUCCESS,
            // payload: action.payload,
            payload: {
              entity: action?.payload?.entity?.company,
              opId: action?.payload?.opId,
            },
          })
          return next({
            ...action,
            payload: restPayload,
          })
        }
        case userActionTypes.ERROR: {
          store.dispatch({
            ...action,
            type: companyActionTypes.ERROR,
          })
          return next(action)
        }
      }
    }
    return next(action)
  }

export default companyMiddleware
